__webpack_require__.p = "/offer-content-generator/referrals-hub/";